(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec9e7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec9e7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("d7rjb", function(module, exports) {

$parcel$export(module.exports, "default", () => $98d11cac84a4afb7$export$2e2bcd8739ae039);
class $98d11cac84a4afb7$var$VideoUtils {
    constructor(){
        // Initialize caches for players
        this.vimeoPlayers = new Map();
        this.youtubePlayers = new Map();
        this.videoMuteStatus = new Map(); // Track muted status per video/iframe
    }
    // Push video interaction to the GTM data layer
    pushVideoEventToDataLayer(eventAction, videoType, videoLabel) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "video_interaction",
            video_action: eventAction,
            video_type: videoType,
            video_label: videoLabel
        });
    //console.log(`Event pushed: ${eventAction}, Type: ${videoType}, Label: ${videoLabel}`);
    }
    // Enable YouTube API if not already enabled
    enableYouTubeAPI(iframe) {
        if (iframe.src.includes("youtube.com") && !iframe.src.includes("enablejsapi=1")) iframe.src += (iframe.src.includes("?") ? "&" : "?") + "enablejsapi=1";
    }
    // Load YouTube API dynamically
    loadYouTubeAPI() {
        return new Promise((resolve)=>{
            if (window.YT && window.YT.Player) resolve(); // API already loaded
            else {
                const script = document.createElement("script");
                script.src = "https://www.youtube.com/iframe_api";
                script.async = true;
                window.onYouTubeIframeAPIReady = ()=>resolve(); // Wait for API to load
                document.head.appendChild(script);
            }
        });
    }
    // Load Vimeo Player API once (PHP also enqueues it; this waits or loads as fallback)
    loadVimeoAPI() {
        if (typeof Vimeo !== "undefined" && Vimeo?.Player) return Promise.resolve();
        if (this._vimeoApiPromise) return this._vimeoApiPromise;
        this._vimeoApiPromise = new Promise((resolve, reject)=>{
            const src = "https://player.vimeo.com/api/player.js";
            const existing = document.querySelector(`script[src*="player.vimeo.com/api/player.js"]`);
            const onReady = ()=>{
                if (typeof Vimeo !== "undefined" && Vimeo?.Player) resolve();
                else reject(new Error("Vimeo Player API failed to initialize"));
            };
            if (existing) {
                if (typeof Vimeo !== "undefined" && Vimeo?.Player) {
                    resolve();
                    return;
                }
                existing.addEventListener("load", onReady, {
                    once: true
                });
                existing.addEventListener("error", reject, {
                    once: true
                });
                return;
            }
            const script = document.createElement("script");
            script.src = src;
            script.async = true;
            script.onload = onReady;
            script.onerror = reject;
            document.head.appendChild(script);
        });
        return this._vimeoApiPromise;
    }
    // Initialize YouTube Player and cache it
    async initializeYouTubePlayer(iframe, eventHandlers) {
        await this.loadYouTubeAPI();
        const youtubePlayer = new YT.Player(iframe, {
            events: {
                onReady: eventHandlers.onReady || (()=>{}),
                onStateChange: eventHandlers.onStateChange || (()=>{})
            }
        });
        this.youtubePlayers.set(iframe, youtubePlayer);
        return youtubePlayer;
    }
    // Setup progress tracking for both Vimeo and YouTube players
    setupProgressTracking(player, type, source) {
        const progressMarkers = {
            25: false,
            50: false,
            75: false,
            99: false
        };
        const trackProgress = (percentage)=>{
            Object.keys(progressMarkers).forEach((marker)=>{
                if (percentage >= marker && !progressMarkers[marker]) {
                    this.pushVideoEventToDataLayer(`progress_${marker}`, type, source);
                    progressMarkers[marker] = true;
                }
            });
        };
        if (type === "Vimeo") player.on("timeupdate", (data)=>{
            const percentage = data.seconds / data.duration * 100;
            trackProgress(percentage);
        });
        else if (type === "YouTube") {
            const interval = setInterval(()=>{
                const percentage = player.getCurrentTime() / player.getDuration() * 100;
                trackProgress(percentage);
                if (percentage >= 99) clearInterval(interval);
            }, 1000);
        }
    }
    // Handle FancyBox close and reset video playback
    setupFancyBoxCloseHandler(iframe, type, playButton = null, callback = null) {
        const player = type === "Vimeo" ? this.getVimeoPlayer(iframe) : this.getYouTubePlayer(iframe);
        jQuery(document).on("afterClose.fb", async ()=>{
            try {
                if (player) type === "Vimeo" ? await player.play() : player.playVideo();
                if (playButton) {
                    playButton.textContent = "Pause";
                    playButton.classList.add("playing");
                }
                if (typeof callback === "function") callback();
            } catch (error) {}
        });
    }
    // Play and control mute for Vimeo Video
    async playAndControlVimeo(iframe, mute = false) {
        try {
            await this.loadVimeoAPI();
        } catch (error) {
            return;
        }
        const player = this.getVimeoPlayer(iframe);
        if (!player) return;
        try {
            await player.ready();
            const isPaused = await player.getPaused();
            await player.setVolume(mute ? 0 : 1);
            if (isPaused) await player.play();
        } catch (error) {}
        this.setupProgressTracking(player, "Vimeo", iframe.src);
    }
    // Play YouTube video
    async playYouTube(iframe, eventHandlers = {}) {
        this.enableYouTubeAPI(iframe);
        const player = await this.initializeYouTubePlayer(iframe, eventHandlers);
        player.playVideo();
        this.setupProgressTracking(player, "YouTube", iframe.src);
    }
    // Pause Vimeo video
    async pauseVimeo(iframe) {
        try {
            await this.loadVimeoAPI();
        } catch (error) {
            return;
        }
        const player = this.getVimeoPlayer(iframe);
        if (!player) return;
        try {
            await player.pause();
        } catch (error) {}
    }
    // Pause YouTube video
    async pauseYouTube(iframe) {
        const player = this.youtubePlayers.get(iframe);
        if (player) try {
            player.pauseVideo();
        } catch (error) {}
    }
    async isVimeoPlaying(iframe, maxAttempts = 10, interval = 200) {
        try {
            await this.loadVimeoAPI();
        } catch (error) {
            return false;
        }
        const player = this.getVimeoPlayer(iframe);
        if (!player) return false;
        try {
            await player.ready(); // Ensure the player is initialized
            let attempts = 0;
            while(attempts < maxAttempts){
                const isPaused = await player.getPaused();
                if (!isPaused) //console.log(`Vimeo video is playing (after ${attempts + 1} attempts): ${iframe.src}`);
                return true; // Video is playing
                attempts++;
                await new Promise((resolve)=>setTimeout(resolve, interval)); // Wait before retrying
            }
            //console.log(`Vimeo video is not playing after ${maxAttempts} attempts: ${iframe.src}`);
            return false; // Default to not playing if state doesn't stabilize
        } catch (error) {
            return false;
        }
    }
    // Check if YouTube video is playing
    async isYouTubePlaying(iframe) {
        const player = this.youtubePlayers.get(iframe);
        if (player) {
            const state = player.getPlayerState();
            return state === YT.PlayerState.PLAYING;
        }
        return false;
    }
    // Get or create Vimeo player
    getVimeoPlayer(iframe) {
        if (typeof Vimeo === "undefined" || !Vimeo?.Player) return null;
        if (!this.vimeoPlayers.has(iframe)) try {
            const player = new Vimeo.Player(iframe);
            this.vimeoPlayers.set(iframe, player);
        } catch (e) {
            return null;
        }
        return this.vimeoPlayers.get(iframe);
    }
    discardVimeoPlayer(iframe) {
        const player = this.vimeoPlayers.get(iframe);
        this.vimeoPlayers.delete(iframe);
        if (player && typeof player.destroy === "function") player.destroy().catch(()=>{});
    }
    // Get or create YouTube player
    getYouTubePlayer(iframe) {
        return this.youtubePlayers.get(iframe);
    }
}
const $98d11cac84a4afb7$var$videoUtils = new $98d11cac84a4afb7$var$VideoUtils();
var $98d11cac84a4afb7$export$2e2bcd8739ae039 = $98d11cac84a4afb7$var$videoUtils;

});


var $d7rjb = parcelRequire("d7rjb");
const $35a6db195d6d1e4f$var$playHTML5Video = async (video)=>{
    try {
        await video.play();
    } catch (e) {
    /* Autoplay or policy blocked */ }
};
const $35a6db195d6d1e4f$var$copyImageVideo = ()=>{
    const videoBlocks = document.querySelectorAll(".copy-image-video__media");
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                const block = entry.target;
                $35a6db195d6d1e4f$var$initializeVideoBlock(block);
                observer.unobserve(block); // Unobserve after initialization
            }
        });
    });
    videoBlocks.forEach((block)=>observer.observe(block));
};
// Initialize a single video within the block
const $35a6db195d6d1e4f$var$initializeVideoBlock = async (block)=>{
    const controls = block.querySelector(".video-controls");
    const playButton = controls?.querySelector(".play-button");
    const muteButton = controls?.querySelector(".mute-button");
    const fullButton = controls?.querySelector(".full-button");
    const videoWrapper = block.querySelector(".copy-image-video__media-video");
    if (!videoWrapper) return;
    const applyPosterFallback = ()=>{
        block.classList.add("copy-image-video__media--video-unavailable");
        videoWrapper.classList.remove("visible");
        videoWrapper.setAttribute("hidden", "");
    };
    //Show Video Wrapper
    videoWrapper.classList.add("visible");
    const video = videoWrapper.querySelector("video");
    const iframe = videoWrapper.querySelector("iframe");
    // Show controls (fade-in)
    const showControls = ()=>{
        if (controls) controls.classList.add("visible");
    };
    // HTML5 Video: Show controls after video is loaded
    if (video) video.addEventListener("loadeddata", showControls);
    // Vimeo: wait for player; on permission/embed errors fall back to still image
    if (iframe && iframe.src.includes("vimeo.com")) {
        iframe.setAttribute("loading", "lazy");
        try {
            await (0, $d7rjb.default).loadVimeoAPI();
        } catch (e) {
            applyPosterFallback();
            return;
        }
        const player = (0, $d7rjb.default).getVimeoPlayer(iframe);
        if (!player) {
            applyPosterFallback();
            return;
        }
        try {
            await player.ready();
        } catch (e) {
            (0, $d7rjb.default).discardVimeoPlayer(iframe);
            applyPosterFallback();
            return;
        }
        showControls();
    } else if (iframe) {
        iframe.setAttribute("loading", "lazy");
        iframe.src.includes("youtube.com");
    }
    // Set a fixed aspect ratio to prevent layout shifts
    videoWrapper.style.aspectRatio = "16/9";
    // Update play button visibility based on playback state
    const updatePlayButtonVisibility = (isPaused)=>{
        if (!playButton) return;
        if (isPaused) {
            playButton.classList.add("visible");
            playButton.classList.remove("playing");
            playButton.textContent = "Play";
        } else {
            playButton.classList.remove("visible");
            playButton.classList.add("playing");
            playButton.textContent = "Pause";
        }
    };
    // Synchronize mute button state with video/iframe
    const syncMuteButtonState = async ()=>{
        if (!muteButton) return;
        let isMuted;
        if (video) isMuted = video.muted;
        else if (iframe) {
            if (iframe.src.includes("vimeo.com")) {
                const player = (0, $d7rjb.default).getVimeoPlayer(iframe);
                if (!player) return;
                const currentVolume = await player.getVolume();
                isMuted = currentVolume === 0;
            } else if (iframe.src.includes("youtube.com")) {
                const player = (0, $d7rjb.default).getYouTubePlayer(iframe);
                const currentVolume = player.getVolume();
                isMuted = currentVolume === 0;
            }
        }
        muteButton.classList.toggle("mute", isMuted);
        muteButton.textContent = isMuted ? "Unmute" : "Mute";
    };
    const toggleMute = async (video, iframe, muteButton)=>{
        try {
            // Check current mute state
            let isMuted;
            if (video) {
                // HTML5 video
                isMuted = video.muted;
                video.muted = !isMuted; // Toggle mute state
            } else if (iframe) {
                if (iframe.src.includes("vimeo.com")) {
                    // Vimeo iframe
                    const player = (0, $d7rjb.default).getVimeoPlayer(iframe);
                    if (!player) return;
                    const currentVolume = await player.getVolume();
                    isMuted = currentVolume === 0; // Consider muted if volume is 0
                    await player.setVolume(isMuted ? 1 : 0); // Toggle volume
                } else if (iframe.src.includes("youtube.com")) {
                    // YouTube iframe
                    const player = await (0, $d7rjb.default).getYouTubePlayer(iframe);
                    const currentVolume = player.getVolume();
                    isMuted = currentVolume === 0; // Consider muted if volume is 0
                    player.setVolume(isMuted ? 100 : 0); // Toggle volume
                }
            }
            // Update mute button state
            muteButton.classList.toggle("mute", !isMuted); // Add 'un-mute' class if now muted
            muteButton.textContent = !isMuted ? "Unmute" : "Mute"; // Update button text
        } catch (error) {}
    };
    // Detect autoplay and set initial state
    const detectAutoplay = async ()=>{
        if (video) {
            updatePlayButtonVisibility(video.paused);
            video.muted = true; // Ensure autoplayed video starts muted
        } else if (iframe) {
            if (iframe.src.includes("vimeo.com")) try {
                const player = (0, $d7rjb.default).getVimeoPlayer(iframe);
                if (!player) {
                    applyPosterFallback();
                    return;
                }
                const isPlaying = await (0, $d7rjb.default).isVimeoPlaying(iframe);
                await player.setVolume(0); // Start muted
                updatePlayButtonVisibility(!isPlaying);
            } catch (e) {
                (0, $d7rjb.default).discardVimeoPlayer(iframe);
                applyPosterFallback();
                return;
            }
            else if (iframe.src.includes("youtube.com")) {
                const isPlaying = await (0, $d7rjb.default).isYouTubePlaying(iframe);
                updatePlayButtonVisibility(!isPlaying);
                const player = (0, $d7rjb.default).getYouTubePlayer(iframe);
                if (player) player.mute(); // Start muted
            }
        }
        // Sync mute button state after ensuring video starts muted
        await syncMuteButtonState();
    };
    // Event listeners for iframe
    const setupIframeListeners = async ()=>{
        if (iframe && iframe.src.includes("vimeo.com")) {
            try {
                await (0, $d7rjb.default).loadVimeoAPI();
            } catch (e) {
                return;
            }
            const player = (0, $d7rjb.default).getVimeoPlayer(iframe);
            if (!player) return;
            player.on("play", ()=>updatePlayButtonVisibility(false));
            player.on("pause", ()=>updatePlayButtonVisibility(true));
        } else if (iframe && iframe.src.includes("youtube.com")) await (0, $d7rjb.default).initializeYouTubePlayer(iframe, {
            onStateChange: (event)=>{
                if (event.data === YT.PlayerState.PAUSED) updatePlayButtonVisibility(true);
                else if (event.data === YT.PlayerState.PLAYING) updatePlayButtonVisibility(false);
            }
        });
    };
    // Play/Pause Video Handler
    const toggleVideoPlayPause = async ()=>{
        if (video) {
            if (video.paused) {
                await $35a6db195d6d1e4f$var$playHTML5Video(video);
                updatePlayButtonVisibility(false);
            } else {
                video.pause();
                updatePlayButtonVisibility(true);
            }
        } else if (iframe) {
            if (iframe.src.includes("vimeo.com")) {
                const isPlaying = await (0, $d7rjb.default).isVimeoPlaying(iframe);
                if (isPlaying) {
                    await (0, $d7rjb.default).pauseVimeo(iframe);
                    updatePlayButtonVisibility(true);
                } else {
                    await (0, $d7rjb.default).playAndControlVimeo(iframe);
                    updatePlayButtonVisibility(false);
                }
            } else if (iframe.src.includes("youtube.com")) {
                const isPlaying = await (0, $d7rjb.default).isYouTubePlaying(iframe);
                if (isPlaying) {
                    await (0, $d7rjb.default).pauseYouTube(iframe);
                    updatePlayButtonVisibility(true);
                } else {
                    await (0, $d7rjb.default).playYouTube(iframe);
                    updatePlayButtonVisibility(false);
                }
            }
        }
    };
    // Fullscreen and FancyBox Handler
    const fullScreenPlayPauseHandler = ()=>{
        if (fullButton) fullButton.classList.add("active");
        if (playButton && playButton.classList.contains("playing")) toggleVideoPlayPause(); // Pause video and toggle button state
        (0, $d7rjb.default).setupFancyBoxCloseHandler(iframe || video, video ? "HTML5" : "Vimeo", playButton, ()=>{
            if (playButton && !playButton.classList.contains("playing")) toggleVideoPlayPause(); // Resume video and toggle button state
        });
    };
    // Attach event listeners
    if (muteButton) muteButton.addEventListener("click", ()=>toggleMute(video, iframe, muteButton));
    if (playButton) playButton.addEventListener("click", toggleVideoPlayPause);
    if (fullButton) fullButton.addEventListener("click", fullScreenPlayPauseHandler);
    await setupIframeListeners();
    await detectAutoplay();
    // HTML5 Video Event Listeners
    if (video) {
        video.addEventListener("play", ()=>updatePlayButtonVisibility(false));
        video.addEventListener("pause", ()=>updatePlayButtonVisibility(true));
    }
};
// Preload the first video for better LCP (HTML5 only – do not preload iframe/Vimeo/YouTube)
const $35a6db195d6d1e4f$var$preloadFirstVideo = ()=>{
    const firstBlock = document.querySelector(".copy-image-video__media-video");
    if (!firstBlock) return;
    const video = firstBlock.querySelector("video");
    if (!video || !video.src) return;
    // Only preload direct video sources; iframe URLs (Vimeo/YouTube) must not be preloaded
    // with link preload – the browser treats them as unused and triggers CWV warnings.
    const preloadLink = document.createElement("link");
    preloadLink.rel = "preload";
    preloadLink.as = "video";
    preloadLink.href = video.src;
    document.head.appendChild(preloadLink);
};
// Initialize blockVideo on DOMContentLoaded
document.addEventListener("DOMContentLoaded", ()=>{
    $35a6db195d6d1e4f$var$preloadFirstVideo();
    $35a6db195d6d1e4f$var$copyImageVideo();
    // Select all blocks and make them visible
    const blocks = document.querySelectorAll(".block-copy-image-video");
    blocks.forEach((block)=>{
        requestAnimationFrame(()=>{
            block.classList.add("visible");
        });
    });
});

})();
//# sourceMappingURL=copy-image-video.js.map
